/* Local care-topic selection only. Native supplied instructions stay visible;
 * printing reuses the existing product-guide controls. No API or storage. */
(function () {
  'use strict';
  const sheet = document.querySelector('[data-care-sheet]');
  if (!sheet || sheet.dataset.careBound === 'true') return;
  const select = sheet.querySelector('[data-care-select]'), chooser = sheet.querySelector('[data-care-chooser]');
  const topics = [...sheet.querySelectorAll('[data-care-topic]')];
  if (!select || !chooser || !topics.length) return;
  const allowed = new Set(['general', ...topics.map(topic => topic.dataset.careTopic)]);
  let requested;
  try { requested = new URLSearchParams(location.search).get('topic'); } catch (_) { requested = null; }
  const initial = allowed.has(requested) ? requested : allowed.has(sheet.dataset.careDefault) ? sheet.dataset.careDefault : 'general';
  function show(value) {
    const chosen = allowed.has(value) ? value : 'general';
    for (const topic of topics) { topic.open = topic.dataset.careTopic === chosen; topic.hidden = !topic.open; }
    select.value = chosen;
  }
  let beforePrint = null;
  window.addEventListener('beforeprint', () => {
    beforePrint = topics.map(topic => ({ topic, open: topic.open, hidden: topic.hidden }));
    for (const topic of topics) {
      const selected = topic.dataset.careTopic === select.value;
      topic.hidden = !selected; topic.open = selected;
    }
  });
  window.addEventListener('afterprint', () => {
    if (!beforePrint) return;
    for (const state of beforePrint) { state.topic.open = state.open; state.topic.hidden = state.hidden; }
    beforePrint = null;
  });
  sheet.dataset.careBound = 'true'; select.addEventListener('change', () => show(select.value));
  chooser.hidden = false; show(initial);
})();
